var _a;
import { ThemeBreakpoints } from '../breakpoints';
var optionList = (_a = {},
    _a[ThemeBreakpoints.MOBILE] = {
        width: '248px',
        fontSize: '14px',
        padding: '18px 20px',
    },
    _a[ThemeBreakpoints.SMALL] = {
        width: '248px',
        fontSize: '14px',
        padding: '18px 20px',
    },
    _a[ThemeBreakpoints.MEDIUM] = {
        width: '264px',
        fontSize: '16px',
        padding: '18px 20px',
    },
    _a[ThemeBreakpoints.LARGE] = {
        width: '392px',
        fontSize: '14px',
        padding: '18px 20px',
    },
    _a);
export default optionList;
